<template>
  <div class="cart_row giftcard" v-if="false">
    <!-- <pre>product: {{product}}</pre> -->
    <div class="flex">
      <!--      <figure></figure>-->

      <router-link
        tag="figure"
        :to="link"
        activeClass="active"
        :style="'background-image: url(' + logoLight + ')'"
      ></router-link>
      <!-- <hgroup @click.prevent="modifyLink">
        <h4>{{product.ProductName}}</h4>
        <div>{{product.RecipientName}}</div>
        <div class="flex">
          <span>{{product.RecipientEmail}}</span>
          <span>
            <currency :value="product.SubTotal" />
          </span>
        </div>
        
      </hgroup> -->
      <router-link class="hgroup" :to="link" activeClass="active">
        <h4 class="-flex_bottom">
          <span v-html="product.ProductName"></span
          ><span class="ml-1 bullet">Edit</span>
        </h4>
        <div>{{ product.RecipientName }}</div>
        <div class="flex">
          <span>{{ product.RecipientEmail }}</span>
          <span> <currency :value="product.GiftCardAmount"/></span>
        </div>
        <pre>OrderMerchandiseKey: {{ product.OrderMerchandiseKey }}</pre>
      </router-link>
    </div>
    <!-- 
    <section class="flex mt-2 mb-1">
      <h4>Subtotal</h4>
      <h4>
        <currency :value="product.SubTotal" />
      </h4>
    </section>-->
    <!-- <section class="flex mt-2 mb-0">
      <small>&nbsp;</small>
      <div>
        <a class="text-blue" href @click.prevent="modifyLink">Edit gift card</a>
      </div>
    </section>-->
    <a
      class="close_button"
      v-on:click.prevent="
        confirmRemoveFromCart({ ...product, isPackage: false })
      "
    ></a>
  </div>
  <div v-else>
    <router-link :to="link">
      <div class="cart-row-item">
        <a
          class="delete_button"
          v-on:click.prevent="
            confirmRemoveFromCart({ ...product, isPackage: false })
          "
        ></a>
        <div class="activity-image">
          <div
            class="client-logo"
            :style="'background-image: url(' + logoLight + ')'"
          ></div>
        </div>
        <div class="row-desc">
          <div class="text_size-large text_style-bold" v-html="product.ProductName">
          </div>
          <div class="text_size-medium">{{ product.RecipientName }}</div>
          <div class="text_size-medium">
            {{ product.RecipientEmail }}
            <span class="subtotal">
              <currency :value="product.GiftCardAmount" />
            </span>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "CartRowGiftCard",
  props: ["product"],
  methods: {
    ...mapActions(["confirmRemoveFromCart"]),
    modifyLink() {
      var identifier = this.product.OrderMerchandiseKey;

      var path =
        "/" +
        this.$route.params.client +
        "/giftcard" +
        "/modify" +
        "/" +
        identifier +
        "/" +
        (this.$route.params.clientAgentKey
          ? this.$route.params.clientAgentKey
          : "n");

      //alert(path);

      this.$router.push({
        path: path,
        name: "giftcardModify",
      });
    },
  },
  computed: {
    ...mapState(["client"]),
    ...mapGetters(["logoLight"]),
    link() {
      var identifier = this.product.OrderMerchandiseKey;

      var path =
        "/" +
        this.$route.params.client +
        "/giftcard" +
        "/modify" +
        "/" +
        identifier +
        "/" +
        (this.$route.params.clientAgentKey
          ? this.$route.params.clientAgentKey
          : "n");

      return path;
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-row-item {
  grid-template-columns: 70px auto;
}

.activity-image {
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(75, 75, 75);
  background: linear-gradient(
    45deg,
    rgba(75, 75, 75, 1) 0%,
    rgba(142, 142, 142, 1) 100%
  );
}

.client-logo {
  height: 95%;
  width: 95%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.subtotal {
  float: right;
}
</style>
